import { ValidatorFn, Validators } from '@angular/forms';

export function CityNameValidator(): ValidatorFn {
  return Validators.pattern(/^\p{L}+(?:[ '-]\p{L}+)*$/u);
}
